import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  IGetConsultationListResponse,
  IConsultationListPayload,
} from "models/consultation/list";
import { httpStatus } from "configs/httpStatus";
import { fetchConsultationList } from "services/consultationList";
import {
  handleSuccessAction,
  handleErrorAction,
} from "./consultationListActions";

function* getConsultationListSaga({
  payload,
}: {
  payload: IConsultationListPayload;
}) {
  try {
    const response: IGetConsultationListResponse = yield call(
      fetchConsultationList,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccessAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetConsultationListWatcher() {
  yield takeLatest(
    ActionType.GET_CONSULTATION_LIST as any,
    getConsultationListSaga
  );
}

export default [fork(onGetConsultationListWatcher)];
